var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBodyicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 110.5,
    height: 59.402,
    viewBox: "0 0 110.5 59.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    "data-name": "Rectangle 356",
    width: 110.5,
    height: 59.402,
    fill: "#717354"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M105.029,21.133a43.6,43.6,0,0,0-9.752-.051q1.456,1.762,2.95,3.485a145.618,145.618,0,0,0-15.207,9.1A189.586,189.586,0,0,1,64.579,8.922Q61.831,4.53,59.324,0q-1.989.121-4.073.121T51.178,0q-2.507,4.529-5.256,8.922A189.587,189.587,0,0,1,27.48,33.671a145.618,145.618,0,0,0-15.207-9.1q1.494-1.722,2.95-3.485a43.584,43.584,0,0,0-9.751.051q-.865.969-1.742,1.925L0,27.125,4.821,29.4A138.269,138.269,0,0,1,26.077,41.9l2.385,1.7,2.015-2.212A197.071,197.071,0,0,0,53.811,9.928q.73-1.217,1.44-2.444.709,1.227,1.438,2.444A197.156,197.156,0,0,0,80.023,41.389L82.038,43.6l2.387-1.7a138.269,138.269,0,0,1,21.256-12.5l4.819-2.276-3.731-4.068q-.876-.955-1.74-1.925",
    transform: "translate(0 0)",
    fill: "#717354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M31.309,25.916c7.1,12.932,11.426,18.821,11.828,25.762.4-6.941,4.726-12.83,11.828-25.762q-2.494-2.871-4.779-5.952A50.157,50.157,0,0,0,43.137,35.85a50.185,50.185,0,0,0-7.048-15.886q-2.284,3.077-4.78,5.952",
    transform: "translate(12.112 7.723)",
    fill: "#717354"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyicon);
export default __webpack_public_path__ + "static/media/bodyicon.75d5676fbfb05f649786c9065ac258e3.svg";
export { ForwardRef as ReactComponent };